const tmrCallback = [[{
    id  : 3411298,
    goal: 'call-back-form'
}, {
    id  : 3391901,
    goal: 'call-back-form'
}, {
    id  : 3391900,
    goal: 'call-back-form'
}, {
    id  : 3411299,
    goal: 'call-back-form'
}, {
    id  : 3411441,
    goal: 'call-back-form'
}], [{
    id  : '2741534',
    goal: 'send_form'
}, {
    id  : '2741534',
    goal: 'CallBack'
}]];

const tmrReservation = [[{
    id  : 3411298,
    goal: 'reservation'
}, {
    id  : 3391901,
    goal: 'reservation'
}, {
    id  : 3391900,
    goal: 'reservation'
}, {
    id  : 3411299,
    goal: 'reservation'
}, {
    id  : 3411441,
    goal: 'reservation'
}], [{
    id  : '2741534',
    goal: 'send_form'
}, {
    id  : '2741534',
    goal: 'reservation'
}]];

const tmrMortgage = [[{
    id  : 3411298,
    goal: 'mortgage'
}, {
    id  : 3391901,
    goal: 'mortgage'
}, {
    id  : 3391900,
    goal: 'mortgage'
}, {
    id  : 3411299,
    goal: 'mortgage'
}, {
    id  : 3411441,
    goal: 'mortgage'
}], [{
    id  : '2741534',
    goal: 'send_form'
}, {
    id  : '2741534',
    goal: 'reservation'
}]];

const tmrClickPhone = [[{
    id  : 3411298,
    goal: 'call'
}, {
    id  : 3391901,
    goal: 'call'
}, {
    id  : 3391900,
    goal: 'call'
}, {
    id  : 3411299,
    goal: 'call'
}, {
    id  : 3411441,
    goal: 'call'
}, {
    id  : 2741534,
    goal: 'click_phone'
}]];

const dspDefault = [{
    id: '225341',
    sz: '21'
}, {
    id: '225341',
    sz: '24'
}];

const setOfGoals = {
    callback: {
        adRiver: [{
            id: 225341,
            sz: '2'
        }, {
            id: 225738,
            sz: 'sending_a_callback_form'
        }, {
            id: 225737,
            sz: 'sending_a_callback_form'
        }],
        tmr: tmrCallback,
        dsp: dspDefault,
        ya : [[{
            id: 'form_callback_sms'
        }], [{
            id: 'form_callback_sent'
        }, {
            id  : 'send_form',
            name: 'Заказ звонка'
        }]],
        ga: [['form_callback_sms'], ['form_callback_sent']]
    },
    view: {
        adRiver: [{
            id: 225341,
            sz: '3'
        }],
        tmr: tmrCallback,
        dsp: dspDefault,
        ya : [[{
            id: 'form_callback_sms'
        }], [{
            id: 'form_objectViewing_sent'
        }, {
            id  : 'send_form',
            name: 'Запись на просмотр'
        }]],
        ga: [['form_objectViewing_sms', 'form_callback_sms'], ['form_objectViewing_sent']]
    },
    online: {
        tmr: [[], [{
            id  : '2741534',
            goal: 'send_form'
        }, {
            id  : '2741534',
            goal: 'CallBack'
        }]],
        dsp: dspDefault,
        ya : [[], [{
            id: 'form_onlineMeet_sent'
        }, {
            id  : 'send_form',
            name: 'Запись на онлайн встречу'
        }]],
        ga: [[], ['form_onlineMeet_sent']]
    },
    booking: {
        adRiver: [{
            id: 225341,
            sz: '5'
        }, {
            id: 225738,
            sz: 'sending_a_booking_request'
        }, {
            id: 225737,
            sz: 'sending_a_booking_request'
        }],
        tmr: tmrReservation,
        dsp: [{
            id: '225341',
            sz: '22'
        }],
        ya: [[{
            id: 'form_reservation_sms'
        }], [{
            id: 'form_reservation_sent'
        }, {
            id  : 'send_form',
            name: 'Заявка на бронирование'
        }]],
        ga: [['form_reservation_sms'], ['form_reservation_sent']]
    },
    installment: {
        adRiver: [{
            id: 225341,
            sz: '7'
        }, {
            id: 225738,
            sz: 'sending_an_application_for_installment_or_mortgage'
        }, {
            id: 225737,
            sz: 'sending_an_application_for_installment_or_mortgage'
        }],
        tmr: tmrMortgage,
        dsp: [{
            id: '225341',
            sz: '22'
        }],
        ya: [[{
            id: 'form_installment_sms'
        }], [{
            id: 'form_installment_sent'
        }, {
            id  : 'send_form',
            name: 'Заявка на рассрочку'
        }]],
        ga: [['form_installment_sms'], ['form_installment_sent']]
    },
    mortgage: {
        adRiver: [{
            id: 225341,
            sz: '6'
        }, {
            id: 225738,
            sz: 'sending_an_application_for_installment_or_mortgage'
        }, {
            id: 225737,
            sz: 'sending_an_application_for_installment_or_mortgage'
        }],
        tmr: tmrMortgage,
        dsp: [{
            id: '225341',
            sz: '20'
        }],
        ya: [[{
            id: 'form_mortgage_sms'
        }], [{
            id: 'form_mortgage_sent'
        }, {
            id  : 'send_form',
            name: 'Заявка на ипотеку'
        }]],
        ga: [['form_mortgage_sms'], ['form_mortgage_sent']]
    },
    assignment: {
        adRiver: [{
            id: 225341,
            sz: '8'
        }],
        tmr: [[], [{
            id  : '2741534',
            goal: 'send_form'
        }]],
        ya: [[], [{
            id: 'form_assignment_sent'
        }, {
            id  : 'send_form',
            name: 'Заявка на переуступку'
        }]],
        ga: [['form_assignment_sms'], ['form_assignment_sent']]
    },
    phoneClick: {
        adRiver: [{
            id: 225341,
            sz: '1'
        }, {
            id: 225738,
            sz: 'call'
        }, {
            id: 225737,
            sz: 'call'
        }],
        tmr: tmrClickPhone
    }
};

const goalYandexHandler = (goal) => {
    if (!window.yaCounter20303818 || !goal) {
        return;
    }

    if (goal.name) {
        // eslint-disable-next-line camelcase
        window.yaCounter20303818.reachGoal(goal.id, {send_form_name: goal.name});
    } else {
        window.yaCounter20303818.reachGoal(goal.id);
    }
};

const goalGoogleHandler = (goal) => {
    if (!window.dataLayer || !goal) {
        return;
    }

    window.dataLayer.push({event: goal});
};

const goalTopMailHandler = (type = 'reachGoal', id, goal) => {
    if (!window._tmr || !goal) {
        return;
    }

    window._tmr.push({
        type,
        id,
        goal
    });
};

const goalAdRiverHandler = (sidID, goal) => {
    try {
        window.adRiverGoalHandler(sidID, goal);
    } catch (error) {
        console.error('adRiver goal handler error', error);
    }
};

const dspGoalHandler = (goal, yaID = '', ctSessionId = '') => {
    if (!window._tmr || !goal) {
        return;
    }

    // eslint-disable-next-line new-cap
    window.DSPCounter('send', {
        sid   : goal.id,
        sz    : goal.sz,
        gid1  : '',
        yid1  : yaID,
        custom: {
            157: ctSessionId
        }
    });
};

export const goalsHandler = (step = 1, formSource) => {
    const currentGoals = setOfGoals[formSource];

    if (step === 1) {
        if (currentGoals.adRiver) {
            currentGoals.adRiver.forEach((goal) => {
                goalAdRiverHandler(goal.id, goal.sz);
            });
        }
    } else if (step === 2 && currentGoals.dsp) {
        try {
            const yaID = window.yaCounter20303818.getClientID();
            const ctSessionId = window.ct('calltracking_params', '10b4640d').sessionId;

            currentGoals.dsp.forEach((goal) => {
                dspGoalHandler(goal, yaID, ctSessionId);
            });
        } catch (error) {
            console.error('dsp goal handler error', error);
        }
    }

    if (currentGoals.ga) {
        currentGoals.ga[step - 1].forEach((goal) => {
            goalGoogleHandler(goal);
        });
    }

    if (currentGoals.tmr) {
        currentGoals.tmr[step - 1].forEach((goal) => {
            goalTopMailHandler('reachGoal', goal.id, goal.goal);
        });
    }

    if (currentGoals.ya) {
        currentGoals.ya[step - 1].forEach((goal) => {
            goalYandexHandler(goal);
        });
    }
};
